import type React from 'react';

function GlimjaIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1636.1 1636.1"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Glimja Icon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <g id="Symbol">
          <ellipse cx="817.82" cy="465.39" rx="220.38" ry="202.01" fill="inherit" />
          <path
            d="M1617.09,543.09c-1.79-9.69-6.28-15.11-11.17-18.49-8.59-5.95-19.79-7.27-30.93-.78-9.35,5.45-9.28,10.21-28.77,19.49-18.37,8.75-33.4,9.74-60.78,9.74-341.47,0-578.09,236.62-623.56,476.02-5.98,31.47-30.34,38.43-43.84,38.5-13.5-.08-37.87-7.04-43.84-38.5-45.47-239.4-282.09-476.02-623.56-476.02-27.37,0-42.4-.99-60.78-9.74-19.49-9.28-19.42-14.03-28.77-19.49-11.13-6.5-22.33-5.17-30.93,.78-4.89,3.38-9.37,8.8-11.17,18.49-1.3,7.05-2.45,46.37-2.45,56.82,0,401.32,354,734.91,801.26,734.91h.46c447.26,0,801.26-333.59,801.26-734.91,0-10.46-1.14-49.77-2.45-56.82Z"
            fill="inherit"
          />
        </g>
        <rect x="0" y="0" width="1636.1" height="1636.1" fill="none" />
      </g>
    </svg>
  );
}

export default GlimjaIcon;
